module.exports = __webpack_public_path__ + "static/media/organization-of-a-public-dialogue-workshop-for-the-SIENNA-project.a3116227.jpg";